export default "__VITE_ASSET__BMb5n4NE__"